<template>
<div>
  <div class="col-md-12 card">
    <div class="card-content row">
      <div class="col-sm-6 col-md-9">
      </div>
      <div class="col-sm-6 col-md-3">
        <p-search @on-search="handleSearch($event)"></p-search>
      </div>
      <div class="col-sm-12">
        <el-table
          class="table-striped"
          :data="tableData"
          :default-sort="{prop: 'createdAt', order: 'descending'}"
          @sort-change="handleSort($event)"
          style="width: 100%"
        >
          <el-table-column
            prop="name"
            label="Nome"
            sortable
            :min-width="200"
          ></el-table-column>
          <el-table-column
            prop="login"
            label="Login"
            sortable
            :min-width="200"
          ></el-table-column>
          <el-table-column
            prop="role"
            label="Função"
            sortable
            :min-width="200"
          >
            <template slot-scope="scope">
            <span class="captalize">{{ scope.row.role }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createdAt"
            label="Criado Em"
            sortable
            :min-width="200"
          >
            <template slot-scope="scope">{{ scope.row.createdAt ? new Date(scope.row.createdAt) : new Date() | moment('DD/MM/YYYY HH:mm:ss') }}
            </template>
          </el-table-column>
          <el-table-column
            :min-width="120"
            fixed="right"
            label=""
          >
            <template slot-scope="props">
            <div class="text-right">
              <router-link :to="{name: 'users.edit', params: {id: props.row._id ? props.row._id : 'none'}}">
                <a class="btn btn-primary btn-fill btn-icon edit"><i class="ti-pencil-alt"></i></a>
              </router-link>

              <inactivate-user-action
                v-if="!props.row.hasOwnProperty('inactivate') || props.row.inactivate !== true"
                :user="props.row"
                @fetch="fetch"
              ></inactivate-user-action>
              <reactivate-user-action
                v-if="props.row.hasOwnProperty('inactivate') && props.row.inactivate === true"
                :user="props.row"
                fetch="fetch"
              ></reactivate-user-action>

              <a
                v-if="$can('user.remove')"
                class="btn btn-danger btn-fill btn-icon remove"
                @click="handleDelete(props.$index, props.row)"
              >
                <i class="ti-trash"></i>
              </a>
            </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="col-sm-12 text-center">
        <p-pagination
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="pagination.total"
        ></p-pagination>
      </div>
    </div>
  </div>
  <div class="col-sm-12 pagination-info text-right">
    <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries {{ count }}</p>
  </div>
</div>
</template>
<script>
import swal from 'sweetalert2'
import InactivateUserAction from './InactivateUserAction'
import ReactivateUserAction from './ReactivateUserAction'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'user-index',

  components: {
    InactivateUserAction,
    ReactivateUserAction
  },
  data () {
    return {
      pagination: {
        perPage: 99999,
        currentPage: 1,
        total: 0
      },
      sort: { field: 'createdAt', direction: 'desc' },
      search: {
        query: '',
        fields: [
          'name',
          'login'
        ]
      }
    }
  },
  watch: {
    currentPage: function (currentPage) {
      this.fetch()
    }
  },
  computed: {
    ...mapGetters('users', {
      count: 'count',
      loading: 'loading',
      user: 'user',
      tableData: 'noAdminAll'
    }),
    to () {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from () {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    total () {
      this.pagination.total = this.count
      return this.count
    },
    currentPage () {
      return this.pagination.currentPage
    }
  },
  methods: {
    ...mapActions('users', [
      'fetchAll',
      'delete'
    ]),
    fetch () {
      this.fetchAll({
        'limit': this.pagination.perPage,
        'skip': this.from,
        'sort': this.sort,
        'search': this.search,
        'where': [{ role: { '$ne': 'superadmin' } }] // Codeseven não deve ser exibido
      })
    },
    handleSearch (query) {
      this.search.query = query
      this.fetch()
    },
    handleSort (sort) {
      this.sort = {
        field: sort.prop,
        direction: sort.order
      }
      this.fetch()
    },
    handleDelete (index, row) {
      swal({
        title: 'Você tem certeza?',
        text: `Não será possível reverter essa ação!`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Sim, pode deletar!',
        buttonsStyling: false
      })
        .then(() => {
          this.delete(row._id)
            .then(result => {
              this.$notify({
                message: 'Registro deletado com sucesso.',
                type: 'success'
              })
              this.fetch()
            })
            .catch(err => console.log(err))
        })
    }
  },
  mounted () {
    this.fetch()
  }
}
</script>
<style>
  .captalize {
    text-transform: capitalize;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Users/UsersIndex.vue